<template>
  <asc-page-loading-indicator
    :loading="isDataLoading && apiPageFailure.length === 0"
  >
    <div class="asc-terms-container">
      <v-container fluid>
        <asc-page-header>
          <template #pageTitle
            ><asc-page-title title="TERMS & CONDITIONS"
          /></template>
        </asc-page-header>
        <asc-terms-and-conditions-template
          :terms-acceptance="termsAcceptance"
        />
      </v-container>
    </div>
  </asc-page-loading-indicator>
</template>

<script>
import { mapState } from 'vuex'
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import { AscTermsAndConditionsTemplate } from '@/components/templates'
import { USER_CONSTS as UC } from '@/stores/consts'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'

export default {
  name: 'AscTermsContainer',

  components: {
    AscPageLoadingIndicator,
    AscTermsAndConditionsTemplate,
    AscPageHeader,
    AscPageTitle,
  },

  data() {
    return {
      isDataLoading: false,
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(UC.NAMESPACE, ['termsAcceptance']),
  },
}
</script>

<style lang="scss">
.asc-terms-container {
  background-color: $gray-100;

  & .container {
    padding: 16px;
  }
}
</style>
